import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const imageResolutionX = 8269;

const directions = [
  { letter: 'ne', deg: 115, isSide: true, },
  { letter: 'e', deg: 160, },
  { letter: 'se', deg: 205, isSide: true,},
  { letter: 's', deg: 250, },
  { letter: 'sw', deg: 295, isSide: true,},
  { letter: 'w', deg: 335, },
  { letter: 'nw', deg: 25, isSide: true,},
  { letter: 'n', deg: 70, },
];

const Compass = ({ angle }) => {
  return (
    <Root angle={angle}>
      {
        directions.map(direction => (
          <Letter left={imageResolutionX*(direction.deg%360)/360/2} key={direction.letter} side={direction.isSide}>{direction.letter}</Letter>
        ))
      }
    </Root>
  );
};

Compass.propsTypes = {
  angle: PropTypes.number,
};

const Root = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  transform: ${props => `translateX(${-1*imageResolutionX*(props.angle%360)/360/2}px)`};
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    border-top: 1px dashed #FF7802;
    width: 15000px;
    height: 1px;
  }
`;

const Letter = styled.p`
  position: absolute;
  top: ${props => props.side ? '-10px' : '-16px'};
  left: ${props => (props.left)+'px'};
  font-family: 'DINOT';
  font-weight: 500;
  font-size: ${props => props.side ? '14px' : '22px'};
  color: #FF7802;
  letter-spacing: 0;
  background-color: #0b1a27;
  padding: 0 4px;
`;

export default Compass;


// WEBPACK FOOTER //
// ./src/pages/Views/elements/Panorama/elements/Compass.js